import BorderedBox from "./BorderedBox";
import {Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from "@mui/material";
import {humanByteSize} from "../../utility/humanReadable";
import React, {useState} from "react";
import {selectUsers} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {Users as UsersType} from "../../redux/types/firebase";
import {IVersion} from "./Versions";
import makeStyles from "@mui/styles/makeStyles";
import VersionDifferences from "./VersionDifferences";

const useStyles = makeStyles(theme => ({
    differentHash: {
        color: theme.palette.warning.main
    },
    table: {
        height: "calc(100% - 56px)",
        overflowY: "scroll",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface IVersionDetails {
    label?: string
    previous?: IVersion
    users: UsersType
    version: IVersion
}
function VersionDetails({label, previous, users, version}: IVersionDetails) {
    const classes = useStyles();
    const [expandedRow, setExpandedRow] = useState<string>();

    return (
        <BorderedBox label={label}>
            <Box display="flex" flexDirection="column" height="100%">
                <Box display="flex">
                    <TextField inputProps={{readOnly: true}} label="User" size="small" sx={{m: 1}}
                               value={users && users[version.user]?.name}/>
                    <TextField inputProps={{readOnly: true}} label="Hash" size="small" sx={{m: 1}}
                               value={version.fingerprint.hash}/>
                    <TextField inputProps={{readOnly: true}} label="Size" size="small" sx={{m: 1}}
                               value={humanByteSize(version.fingerprint.size)}/>
                </Box>
                <Box className={classes.table}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Table</TableCell>
                                    <TableCell>Size</TableCell>
                                    <TableCell>Hash</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.keys(version.fingerprint.tables).map(tableKey => {
                                    const table = version.fingerprint.tables[tableKey];
                                    const previousTable = previous?.fingerprint.tables[tableKey];
                                    const className = previousTable?.hash === table.hash ? "" :
                                        classes.differentHash;

                                    if (expandedRow !== tableKey) {
                                        return (
                                            <TableRow key={tableKey}>
                                                <TableCell className={className}>
                                                    <Button disabled={className === ""} onClick={() => setExpandedRow(tableKey)}>
                                                        {tableKey}
                                                    </Button>
                                                </TableCell>
                                                <TableCell className={className}>
                                                    {humanByteSize(table.size)}
                                                </TableCell>
                                                <TableCell className={className}>{table.hash}</TableCell>
                                            </TableRow>
                                        );
                                    }  else {
                                        return (
                                            <VersionDifferences onClose={() => setExpandedRow(undefined)}
                                                                previous={previousTable} tableKey={tableKey}
                                                                table={table}/>
                                        );
                                    }
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </BorderedBox>
    );
}
const mapStateToProps = (store: never) => ({
    users: selectUsers(store),
});

export default connect(mapStateToProps, {
})(VersionDetails);
